import { kea } from 'kea'
import PropTypes from 'prop-types'

import railsContext from 'lib/selectors/rails-context'

export default kea({
  initScene: {
    scene: 'pagesInvite',

    transform: payload => ({
      isLoggedIn: payload.isLoggedIn,
      inviteBonusClass: payload.inviteBonusClass,
      inviteBonusTeach: payload.inviteBonusTeach,
      personalInvitationUrl: payload.personalInvitationUrl,
      isTeacher: payload.isTeacher,
      facebookApp: payload.facebookApp
    })
  },

  path: () => ['scenes', 'pagesInvite', 'index'],

  connect: {
    props: [railsContext, ['dpr']]
  },

  reducers: () => ({
    isLoggedIn: [false, PropTypes.bool, {}],
    inviteBonusClass: ['', PropTypes.string, {}],
    inviteBonusTeach: ['', PropTypes.string, {}],
    personalInvitationUrl: ['', PropTypes.string, {}],
    isTeacher: [true, PropTypes.bool, {}],
    facebookApp: ['', PropTypes.string, {}]
  })
})
